<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col>
        <v-card>
          <v-card-text>
            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="places"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:item.map="{ item }">
                <v-icon @click="onOpenMap(item.id)">
                  mdi-map-search-outline
                </v-icon>
              </template>
              <template v-slot:item.stateHuman="{item}">
                <v-chip :color="item.state === 0 ? 'success' : 'default'">
                  {{ item.stateHuman }}
                </v-chip>
              </template>
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { JustpayPlace } from "@/views/loyalty/shared/services/justpay-place-service"
import { localStock } from "@/views/loyalty/shared/classes/local_stock"
import { PlaceClass } from "@/views/loyalty/shared/classes/place_class"

export default {
  name: "UserProfilePlaceList",
  data: () => ({
    customerId: null,
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    justpayPlace: null,
    headers: [
      {
        text: "Карта",
        value: "map",
        sortable: false
      },
      {
        text: 'Название',
        value: 'name'
      },
      {
        text: 'Адрес',
        value: 'address'
      },
      {
        text: 'Статус',
        value: 'stateHuman'
      }
    ],
    loading: false,
    places: [],
}),
  async beforeMount () {
    this.justpayPlace = new JustpayPlace()
    this.placeObj = new PlaceClass()
    this.customerId = localStorage.getItem('customer')
  },
  async mounted () {
    this.loading = true
    this.places = await this.getItems()
    console.log('this.places:', this.places)
    this.loading = false
  },
  methods: {
    async getItems () {
      console.log(this.$route.query.id)
      const places = await this.justpayPlace.getPlacesByCustomerId(this.customerId)
      return places.map(place => this.placeObj.addPlace(place).place)
    },
    onOpenMap (placeId) {
      console.log("To open map:", placeId)
      this.$router.push({ name: 'CrowdPlaceView', query: { id: placeId } })
    }
  }
}
</script>

<style scoped>

</style>
